/* eslint-disable no-sequences */
// AXIOS
import axios from "axios";
import { apiUrl_forProductFilters } from "./constants";

// cancel token
const CancelToken = axios.CancelToken;

// get productFilters
export let cancelGetProductFiltersApi;
export async function getProductFilters(headers) {
    if (headers) {
        const productFilters = await axios.get(
            apiUrl_forProductFilters + "filters",
            {
                headers: { ...headers },
                cancelToken: new CancelToken(function executor(c) {
                    cancelGetProductFiltersApi = c;
                }),
            }
        );
        return productFilters;
    } else {
        console.log("Please add required parameters");
    }
}

// update customer
export let cancelupdateProductFiltersApi;
export async function updateProductFilters(headers, filterlist) {
    if ((headers && filterlist)) {
        const customers = await axios.put(
            apiUrl_forProductFilters + "filters",
            filterlist,
            {
                headers: { ...headers },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelupdateProductFiltersApi = c;
                }),
            }
        );
        return customers;
    } else {
        console.log("Please add required parameters");
    }
}
